import * as React from "react";

const SvgArrowGreen = (props) => (
  <svg
    className="arrow-green_svg__arrow-gray"
    viewBox="0 0 304 125"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
    }}
    {...props}
  >
    <path
      d="M0 14.801h46.829v4.915c0 1.04.587 1.98 1.53 2.456.411.205.854.307 1.294.307.576 0 1.149-.174 1.638-.516L68.794 9.732a2.754 2.754 0 0 0 1.183-2.247c0-.89-.444-1.73-1.183-2.248L51.291-6.994a2.857 2.857 0 0 0-2.93-.208 2.744 2.744 0 0 0-1.532 2.456V.169H0c-1.556 0-2.822 1.239-2.822 2.761v9.109c0 1.523 1.266 2.762 2.822 2.762"
      style={{
        fill: "#0f6837",
        fillRule: "nonzero",
      }}
      transform="translate(11.758 31.294) scale(4.16667)"
    />
  </svg>
);

export default SvgArrowGreen;
